import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import EmployeeFlowLayout from 'components/common/subscriber/EmployeeFlowLayout';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { useHealthQuestionnaireEntryPageStore } from 'store/pages/subscriber/imq/health-questionnaire-entry/pageStore';
import { MedicalHistoryEntryCard } from 'components/common/subscriber/imq/health-questionnaire-entry/MedicalHistoryEntryCard';
import { MedicalHistoryAnswer } from 'components/common/subscriber/imq/health-questionnaire-entry/AnswerOption';

const PageContent: React.FC = observer(() => {
  const {
    getInitialData,
    isInitialLoading,
    flowDelegate,
    subscriberHasMedicalConditions,
    setMedicalHistoryAnswer,
    canContinue,
    completeStep,
  } = useHealthQuestionnaireEntryPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  const selectedValue: MedicalHistoryAnswer | '' =
    // eslint-disable-next-line no-nested-ternary
    subscriberHasMedicalConditions === null ? '' : subscriberHasMedicalConditions ? 'yes' : 'no';

  return (
    <EmployeeFlowLayout
      contentWidth="standard"
      flowDelegate={flowDelegate}
      pageId={SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE_ENTRY}
      isInitialLoading={isInitialLoading}
      pageFooter={{
        onComplete: completeStep,
        disableCompleteButton: !canContinue,
        completeButtonText: 'Next',
      }}
    >
      <MedicalHistoryEntryCard selectedValue={selectedValue} onChange={setMedicalHistoryAnswer} />
    </EmployeeFlowLayout>
  );
});

export default PageContent;
